export default "__VITE_ASSET__BtxU3Q9V__"